import React from "react";
import "./DashboardLoadingTemplate.css";

const SkeletonLine = ({ className = "" }: { className?: string }) => (
  <span className={`dashboard-loading-template__line ${className}`} />
);

export const DashboardLoadingTemplate = () => (
  <div
    className="dashboard-loading-template"
    role="status"
    aria-live="polite"
    aria-label="Loading dashboard"
  >
    <span className="sr-only">Loading your dashboard configuration</span>
    <div className="dashboard-loading-template__content" aria-hidden="true">
      <div className="dashboard-loading-template__heading">
        <div>
          <SkeletonLine className="is-title" />
          <SkeletonLine className="is-subtitle" />
        </div>
        <span className="dashboard-loading-template__control" />
      </div>

      <div className="dashboard-loading-template__summary">
        {Array.from({ length: 3 }).map((_, index) => (
          <div className="dashboard-loading-template__card is-summary" key={index}>
            <span className="dashboard-loading-template__icon" />
            <div className="dashboard-loading-template__card-copy">
              <SkeletonLine className="is-label" />
              <SkeletonLine className="is-value" />
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-loading-template__workspace">
        <div className="dashboard-loading-template__card is-primary">
          <SkeletonLine className="is-section-title" />
          <SkeletonLine className="is-section-subtitle" />
          <div className="dashboard-loading-template__chart">
            {Array.from({ length: 7 }).map((_, index) => (
              <span key={index} style={{ height: `${38 + ((index * 17) % 52)}%` }} />
            ))}
          </div>
        </div>

        <div className="dashboard-loading-template__card is-secondary">
          <SkeletonLine className="is-section-title" />
          <SkeletonLine className="is-section-subtitle" />
          <div className="dashboard-loading-template__list">
            {Array.from({ length: 4 }).map((_, index) => (
              <div className="dashboard-loading-template__list-row" key={index}>
                <span className="dashboard-loading-template__avatar" />
                <div>
                  <SkeletonLine className="is-row-title" />
                  <SkeletonLine className="is-row-subtitle" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);
